import { Radio, Spin } from 'antd';
import React, { lazy, Suspense, useState } from 'react';
import classes from './surveyQuestionModalContent.module.scss';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';

const SettingView = lazy(() => import('./settingView'));

const options = [
  {
    value: 'CHOICE_OF_OPTIONS',
    label: 'Choice of Options',
  },
];

function SurveyQuestionModalContent(props) {
  const [selectedType, setSelectedType] = useState('CHOICE_OF_OPTIONS');
  const [isPreviewMode, setIsPreviewMode] = useState(false);

  return (
    <div className={classes['question-layout']}>
      <div className={classes['question-header']}>
        <span className={classes['section-title']}>Add Questions</span>
        <CloseOutlined onClick={props.onChange} />
      </div>
      <div className={classes['question-content']}>
        <div className={classes['question-sidebar']}>
          <span className={classes['section-title']}>Type</span>
          <div>
            <Radio.Group
              options={options}
              className={classes['question-types-radio']}
              value={selectedType}
              onChange={(event) => setSelectedType(event.target.value)}
            />
          </div>
        </div>
        <div
          className={
            isPreviewMode
              ? classes['question-preview']
              : classes['question-body']
          }
        >
          <span
            className={
              isPreviewMode
                ? classes['section-preview-title']
                : classes['section-title']
            }
          >
            {isPreviewMode ? 'Preview' : 'Setting'}
          </span>
          <Suspense
            fallback={
              <div className={classes['loading-fallback']}>
                <Spin indicator={<LoadingOutlined />} size="large" spinning />
              </div>
            }
          >
            <SettingView
              type={selectedType}
              value={props?.value}
              partialUpdateQuestions={props.partialUpdateQuestions}
              isPreviewMode={isPreviewMode}
              togglePreviewMode={() => setIsPreviewMode((prev) => !prev)}
            />
          </Suspense>
        </div>
      </div>
    </div>
  );
}

export default SurveyQuestionModalContent;
